import { PresetItemPayload } from 'config/requests/presets';
import { PresetItemFormValue } from 'pages/Presets/PresetsCreate/PresetsCreateForm/PresetsCreateForm';
import { getId } from 'utils/getId';

export const mapFormValueToPresetItem = (item: PresetItemFormValue): PresetItemPayload => ({
  ...(item.id && { id: item.id }),
  amount: item.amount,
  ...(item.badge && { badge: getId(item.badge) }),
  ...(item.description && { description: item.description }),
});
